var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "28px",
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Special-/-Cross",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }), /*#__PURE__*/React.createElement("g", {
    id: "cross-special"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8225,14 L20.8308333,7.9975 C21.0290365,7.7660565 21.0157105,7.4210534 20.8002452,7.20558812 C20.5847799,6.99012284 20.2397768,6.97679687 20.0083333,7.175 L14,13.1775 L7.9975,7.16916667 C7.7660565,6.97096354 7.4210534,6.98428951 7.20558812,7.19975479 C6.99012284,7.41522007 6.97679687,7.76022317 7.175,7.99166667 L13.1775,14 L7.16916667,20.0025 C7.00269724,20.1450608 6.93018553,20.3689024 6.98144409,20.5819944 C7.03270264,20.7950864 7.19908026,20.961464 7.41217227,21.0127226 C7.62526427,21.0639811 7.8491059,20.9914694 7.99166667,20.825 L14,14.8225 L20.0025,20.8308333 C20.2339435,21.028919 20.5789466,21.0157105 20.7944119,20.8002452 C21.0098772,20.5847799 21.0232031,20.2397768 20.825,20.0083333 L14.8225,14 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero",
    className: "close-button-icon"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseButton);
export default __webpack_public_path__ + "static/media/close-button.c35ad557eee9af58e1470db053873526.svg";
export { ForwardRef as ReactComponent };